import React,{useContext} from "react";
import { CUSTOM_STYLES, CXR_SUBTABS_ID, CXR_TABS, CXR_TABS_ALLOWED_ROLES, PEER_REVIEW_SUBTABS_ID, PEER_REVIEW_TABS, PEER_REVIEW_TABS_ALLOWED_ROLES, ARCHIVED_ACCESS_SUBTABS_ID, ARCHIVED_STUDY_TABS, ARCHIVED_STUDY_ACCESS_TABS_ALLOWED_ROLES,  USERTYPES } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem } from '@fluentui/react';
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../../context/users/UserContext";

const ArchiveStudyAccessTabs = () => {

    const {
        selectedValue,
        handleArchivedStudyRequestTabChange,

      } = useContext(studylistContext);
    const { getThemeColor } = useContext(themeContext);
    const {roles, userId ,contextSwitchUser, isActiveData, peerReviewAdmin, peerReviewEvaluator,} = useContext(userContext);
    const loadSelectedXrayTab = (item)=>{
        console.log("-----Archive STudy Access------", item);
       if(item.props.itemKey === 'pending'){
        handleArchivedStudyRequestTabChange(item.props.itemKey, ARCHIVED_STUDY_TABS.pending, "study_18")
       }else if(item.props.itemKey === 'approved'){
        handleArchivedStudyRequestTabChange(item.props.itemKey, ARCHIVED_STUDY_TABS.approved, "study_19")
       }else if(item.props.itemKey === 'rejected'){
        handleArchivedStudyRequestTabChange(item.props.itemKey, ARCHIVED_STUDY_TABS.rejected, "study_20")
       }
     }

     const getDefaultTab = () => {
      if (selectedValue=="study_18") {
        return "pending";
      }
      if (selectedValue=="study_19") {
        return "approved";
      }
      if (selectedValue=="study_20") {
        return "rejected";
      }
      return null; // Default case
    };

    return (
        <>
        { (ARCHIVED_ACCESS_SUBTABS_ID.includes(selectedValue) && ARCHIVED_STUDY_ACCESS_TABS_ALLOWED_ROLES.includes(roles[0])) && (
        // {/* { (true) && ( */}
             <>
               <div style={{position : "relative", 
               borderLeft: getThemeColor("border"), 
               borderTop: getThemeColor("border")
               }} className="xray-tabs-pivot-top">
                <div className="study-list-hide-cxr-border-top"></div>
                <Pivot  className="xray-tabs-pivot"
                aria-label="Xray tabs"
                linkSize="small"
                linkFormat={'tabs'}
                defaultSelectedKey={getDefaultTab()}
                onLinkClick={(item) => loadSelectedXrayTab(item)}
                >
                  {(roles[0] == USERTYPES.FIRMADMIN)  && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.pending")}>{t("study-list.tabs.pending")} </CustomToolTipHost>} itemKey="pending"></PivotItem>
                  }
                  {(roles[0] == USERTYPES.FIRMADMIN) && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.approved")}> {t("study-list.tabs.approved")}</CustomToolTipHost>} itemKey="approved"> </PivotItem>
                  }
                  {roles[0] == USERTYPES.FIRMADMIN && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.rejected")}> {t("study-list.tabs.rejected")}</CustomToolTipHost>} itemKey="rejected"></PivotItem>
                  }
                </Pivot>
              </div>
             </>
            )}
        </>
    )
}

export default ArchiveStudyAccessTabs;